<template lang="pug">
.switch
  ext-link(
    class="switcher"
    v-for="(item, index) in list"
    :style="item.styles"
    :class="item.classes"
    :to="item.to"
    :key="index"
  )
    Icon(
      :type="item.variant"
      :activeColor="activeColor"
      :selected="item.selected"
    )
    span(
      :class="['inner', item.variant]"
      :style="{ color: item.selected ? activeColor : '#fff' }"
    ) {{ item.text }}
</template>

<script>
import ExtLink from '@/components/ext/Link.vue';
import { Icon } from './components';

export default {
  components: {
    ExtLink,
    Icon,
  },
  props: {
    items: Array,
    styleParams: Object,
  },
  computed: {
    activeColor() {
      return this.styleParams.backgroundColor;
    },
    list() {
      return this.items.map((item, index) => {
        return {
          text: item.text,
          classes: { active: item.selected },
          styles: {
            width: `${100 / this.items.length}%`,
            ...this.styleParams,
            color: item.selected ? this.activeColor : '#fff',
          },
          to: item.to,
          variant: item.variant || '',
          selected: item.selected,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.switch {
  width: 100%;
  margin-bottom: 20px;
  white-space: nowrap;

  .switcher {
    $borderWidth: 2px;
    $borderRadius: 3px;

    cursor: pointer;
    display: inline-block;
    text-decoration: none;
    text-align: center;
    height: 34px;
    line-height: 30px;
    color: #fff;
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    transition: background-color 0.2s ease-in;
    background: #7a78d1;
    border-width: $borderWidth 0 $borderWidth;
    border-style: solid;
    border-color: #7a78d1;
    box-sizing: border-box;
    display: inline-grid;
    grid-template-columns: repeat(2, auto);
    grid-gap: 5px;
    align-items: center;
    justify-content: center;

    .inner {
      display: inline-block;
      height: 100%;
      vertical-align: baseline;
      background-position: left center;
      background-repeat: no-repeat;
    }

    &.active,
    &.router-link-active {
      background-color: #fff !important;

      &:hover {
        background-color: #fff !important;
      }
    }

    &:last-child {
      border-right-width: $borderWidth;
      border-radius: 0 $borderRadius $borderRadius 0;
    }

    &:first-child {
      border-left-width: $borderWidth;
      border-radius: $borderRadius 0 0 $borderRadius;
    }

    &:hover {
      background-color: #9593da;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Switcher.vue?90759df6